export const LEFT_SIDE_BAR = "LEFT_SIDE_BAR";

const initialState = true; 

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case LEFT_SIDE_BAR:
            return action.payload;
        default:
            return state;
    }
}

const storeName = "leftSideBar"

const storeMapping = {[storeName]: reducer};

export const leftSideBarSelector = (state) => state[storeName];

export default storeMapping;